// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"755":"ad044ea724fb7210","888":"dc9a1a3fec33ad25"}[chunkId] + ".css";
};